<script setup lang="ts">
import type { Sg_TopBarItem } from '~/schema/types/generated'

interface Props {
    categories: Sg_TopBarItem[]
}

const { categories } = defineProps<Props>()

const filteredCategories = categories.filter((cat) => cat.title && cat.sg_containers)

const { sendMenuEvent } = useSendEvent()
</script>

<template>
    <PlusBlogLpAtomAccordion
        type="single"
        collapsible
        class="px-3"
    >
        <PlusBlogLpAtomAccordionItem
            v-for="cat in filteredCategories"
            :key="cat?.title ?? ''"
            :value="cat?.title ?? ''"
            class="py-4 data-[state=open]:pb-0"
        >
            <PlusBlogLpAtomAccordionTrigger
                as="h2"
                arrow-style="size-8"
                @click="sendMenuEvent(cat?.title ?? '')"
            >
                <span
                    class="lp-heading-xs capitalize"
                    v-html="cat.title"
                />
            </PlusBlogLpAtomAccordionTrigger>
            <PlusBlogLpAtomAccordionContent>
                <PlusBlogLpMoleculeMenuLinksMobile
                    :cat-title="cat?.title ?? ''"
                    :categories="cat?.sg_containers ?? []"
                />
            </PlusBlogLpAtomAccordionContent>
        </PlusBlogLpAtomAccordionItem>
    </PlusBlogLpAtomAccordion>
</template>
